import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {InputLabel,FormControl,Select as MaterialSelect  ,Box ,TextField
  ,RadioGroup,Radio, Grid, Typography, FormLabel, FormControlLabel} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import {toast} from "react-toastify";
import {ErrorGeneral, llamaApiCargaToken, llamadaApiToken} from "../../funciones/ClienteAxios";
import Modal from '../../Generales/ModalTam';
import Rating from '@material-ui/lab/Rating';
import {DateTimePicker, MuiPickersUtilsProvider, TimePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import esLocale from "date-fns/locale/es";
import moment from 'moment';
const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '20ch',
      }, 
      formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
      selectEmpty: {
        marginTop: theme.spacing(2),
      },
      Textnumero: {
        width: 5+"px",
      },
      formControlFull: {
        //margin: theme.spacing(1),
        //minWidth: 120,
        width:5+"rem"
      },
      margin: {
        margin: theme.spacing(1),
      },
    display: 'flex',
    
    //alignItems: 'center',
    flexDirection:"column"
    },
  }));

const NuevaBitacora = ({modalAbierto, setModalAbierto, titulo, regisPago, renta, funcionActuliza}) => {
  let history = useHistory();
  const classes = useStyles();
  const source = axios.CancelToken.source(); 
  const idusu = localStorage.getItem('UsuId');
  const [espera,setEspera]=useState(false);
  const [mensaje, setMensaje] = useState('');
  const [tipoAdvertencia, setTipoAdvertencia] = useState('success');
  const [aviso, setAviso] = useState(false); 
  const [btnDesact, setBtnDesact] = useState(false); 
  const [radioTipo, setRadioTipo] = useState("1"); 
  const [nvActividad,guardarNvActividad]= useState({Orden:0, Descripcion:'',Marca:'',Unidad:'', Cantidad:"", Gasto3:"", 
    MetodoPago:"", Proveedor:"", ProvCta:"", Importe:"", Impuesto:"", Folio:"", CfdiLink:""});  
  const {Orden, Descripcion, Gasto3, Unidad, Cantidad, MetodoPago, Proveedor, ProvCta, Importe,
    Impuesto,Folio, CfdiLink
  }=nvActividad      
  const [listMetodoPago, setListMetodoPago] = useState([])    
  const [listProveedor, setListProveedor] = useState([])    
  const [listProveedorCta, setListProveedorCta] = useState([])    
  const [listGasto3, setListGasto3 ] = useState([])  
  const [fechas,setFechas]=useState({inicio:new Date() ,final:new Date()});
  const {inicio} =fechas
  React.useEffect(()=>{           
    if (regisPago && regisPago.length!==0) {
      guardarNvActividad({
        ...nvActividad, Orden:regisPago.Id
      })   
    }

    getListMetodoPago()                 
    getListGasto3()
    getListProveedor()
    return ()=> {
      source.cancel();
    }     
    // eslint-disable-next-line react-hooks/exhaustive-deps	
  },[]);

  const getListGasto3 = () => {
      const data = qs.stringify({
        Usuario:idusu,
        ip:"172.0.0.0",
        idDispositivo: '987gyubjhkkjh'
      });
      const url = "/renta/gastotercero/tipo";

      function respuesta(aux) {
        if (aux[0].Id!==-1) 
        {                  
          setListGasto3(aux);                                      
        }         
      }
      llamadaApiToken(data, url, respuesta, ErrorGeneral, history, source);
  }; 

  const getListMetodoPago = () => {
    const data = qs.stringify({
      Usuario:idusu,
      ip:"172.0.0.0",
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/renta/pago/formapago";

    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {                  
        setListMetodoPago(aux);                                      
      }         
    }
    llamadaApiToken(data, url, respuesta, ErrorGeneral, history, source);
  }; 

  const getListProveedor = () => {
    const data = qs.stringify({
      Usuario:idusu,
      ip:"172.0.0.0",
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/renta/proveedor";

    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {                  
        setListProveedor(aux);                                      
      }         
    }
    llamadaApiToken(data, url, respuesta, ErrorGeneral, history, source);
  }; 

  const getListProveedorCta = (auxProveedor) => {
    const data = qs.stringify({
      Usuario:idusu,
      Proveedor:auxProveedor,
      ip:"172.0.0.0",
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/renta/proveedor/cuenta";

    function respuesta(aux) {
      if (aux[0].Id!==-1 && aux[0].Id!==0) 
      {                  
        setListProveedorCta(aux);                                      
      }         
    }
    llamadaApiToken(data, url, respuesta, ErrorGeneral, history, source);
  };

  const registrarNActividad=(FPago)=>{            
   
    const data = qs.stringify({
      Usuario:idusu,
      Renta:renta.Id,
      Llave:0,
      Gasto3:0,
      MetodoPago:MetodoPago,
      Proveedor:Proveedor,
      ProvCta:ProvCta,
      FPago:FPago,
      Importe:Importe,
      Impuesto:Impuesto,
      Folio:Folio,
      CfdiLink:CfdiLink,
      Nota:Descripcion,
      Status:1,
      ip:"172.2.0.0",      
      idDispositivo:'8978yuhjnfrsdsd'
    });
    const url = "/renta/pago/new-edit";
  
    function respuesta(aux) {
      if (aux.respuesta==1) 
      { //console.log(aux);
        let mensaje='Se registro correctamente'
        setTipoAdvertencia("success")      
        setMensaje(mensaje);
        setAviso(true)     
        toast.success(mensaje, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });       
        funcionActuliza(renta.Id)
        setModalAbierto(false)            
      }   
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);     
  }

  const onChange = e =>
  { let expNopermitida = new RegExp('[#_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9]');
    if ((expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value) )||e.target.value===' '||e.target.value==='') 
    {
    
      guardarNvActividad({
        ...nvActividad,
        [e.target.name] : e.target.value  
      })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };

  const onChangeLink = e =>
  { let expNopermitida = new RegExp('[!%({})*|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9:/#_$-d=?.]');
    if ((expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value) )||e.target.value===' '||e.target.value==='') 
    {
    
      guardarNvActividad({
        ...nvActividad,
        [e.target.name] : e.target.value  
      })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };

  const onChangeDesc = e =>
  {      
    guardarNvActividad({
      ...nvActividad,
      [e.target.name] : e.target.value  
    })
    if (aviso) 
    {
      setMensaje('');
      setAviso(false);
    }    
  };

  const onChangeSelect = e =>
  {
    if ('Proveedor' ===e.target.name && (e.target.value!=="" && e.target.value!==0)) {
      getListProveedorCta(e.target.value)  
      setListProveedorCta([])
      guardarNvActividad({
        ...nvActividad,
        [e.target.name] : e.target.value,
        ProvCta:""  
      })
    }
    else{
      guardarNvActividad({
      ...nvActividad,
      [e.target.name] : e.target.value  
    })
    }
    
  };

  const onChangeNum = e =>
  { let expNopermitida = new RegExp('[#A-Za-z_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[0-9]');
    if (expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value)||e.target.value===' '||e.target.value==='') 
    {  
      guardarNvActividad({
        ...nvActividad,
        [e.target.name] : e.target.value  
      })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };
 
    const guardarInicio = auxfecha =>
  {
    setFechas({
      ...fechas,
      inicio : auxfecha  
    })
  };

  const mostrarAlertas =(auxMensaje)=>{ 
    setTipoAdvertencia("warning")
    const mensaje=auxMensaje            
    setMensaje(mensaje);
    setAviso(true)   
  } 

    function valNulos(auxMensaje,auxCampo) 
  {    let valida=false    
    if ( auxCampo !== '' && auxCampo !== '0' && auxCampo !==0 
        && auxCampo !== null && auxCampo!==" " ) 
    {   valida=true              
    }
    if (!valida) 
    {   mostrarAlertas(auxMensaje)
    }
    return valida
  }

  function validaVariable(auxCampo,auxMensaje,auxTamanio) 
  { let respuesta=false
    if ( valNulos(auxMensaje,auxCampo) ) 
    { if (auxCampo.length>=auxTamanio ) 
      {                
        respuesta=true                    
      }else
      {            
        mostrarAlertas(`${auxMensaje}`) 
      }
    }        
    return respuesta;
  }
 
  const validaDatos=(valor, mensaje)=>{
    let respuesta=false    
    if (valor!= null && valor!= '' && valor!= '0' && valor!== 0 ) 
    { respuesta=true     
    }
    else
    { mostrarAlertas(mensaje);    
    }
    return respuesta
  }

   function valNumero(auxNumero,auxCampo) {
    let valida=false    
    if (typeof parseInt(auxNumero) === 'number') 
    {
      if (parseInt(auxNumero) ==0) 
      {
        valida=true
      }  
      else{
        if (parseInt(auxNumero) >0) 
        {  
          valida=true
        } 
      }
    }
    if (!valida) {
      setTipoAdvertencia("warning")
      let mensaje="Llenar campo "+auxCampo            
      setMensaje(mensaje);
      setAviso(true)  
    }
    return valida
  }

  const guardarDatos = () => 
  {
    let auxFecha=moment(inicio).format("YYYY-MM-DDTHH:mm:ss")
    if ( //validaDatos(Gasto3,"Seleccionar Gasto") && 
      validaDatos(MetodoPago, "Seleccionar Metodo Pago.") && 
      validaDatos(Proveedor, "Seleccionar un Proveedor.") &&
      validaDatos(ProvCta, "Seleccionar una Cuenta del Proveedor.") &&
      valNumero(Importe, "Importe") && valNumero(Impuesto, "Impuesto") && 
      validaVariable(Folio, "Llenar campo de Folio (mayor a 5 caracteres)",5) ) 
    {   registrarNActividad(auxFecha)                                   
    }                                           
  };
 
  const fecha=() =>{
    return(  
    <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>                                                          
      <DateTimePicker
        label="Hora" size={"small"} ampm={false}
        value={inicio} style={{width:10+'rem'}}
        onChange={guardarInicio}
        //helperText="Hora"
        minDate="2017-03-14" maxDate={new Date()}
        format="dd/MM/yyyy HH:mm"
        cancelLabel={"Cancelar"} okLabel="Seleccionar"       
      />                          
    </MuiPickersUtilsProvider>)
  }

  return ( 
  <Modal
    titulo={titulo} modalAbierto={modalAbierto}
    setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
    mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
    aviso={aviso} setAviso={setAviso} espera={espera} 
    setEspera={setEspera}  tamanio={"sm"} btnDesact={btnDesact}
  >
  <form className={classes.root} noValidate autoComplete="off" fullWidth style={{width:29+'rem'}} >   
    
                                       
      <Box display="flex" flexDirection="row" my={2}> 
        <Box mr={1}>
        {fecha()}          
        </Box>
        {/* listGasto3.length !==0 ?
        <Box mr={1}>
        <FormControl className={classes.formControl} size="small" style={{width:10+'rem' }}>
          <InputLabel htmlFor="age-native-simple">GastoTercero</InputLabel>
          <MaterialSelect style={{width: 10+"rem",borderRadius:3+'px'}} 
            native value={Gasto3}   
            onChange={onChangeSelect}
            inputProps={{ name: 'Gasto3', id: 'Gasto3', }}            
          >
            <option aria-label="None" value="" />      
            {listGasto3.map((row) => (
             row.Id!==0&& <option value={row.Id}>{row.Descr}</option>
            ))}   
          </MaterialSelect>
        </FormControl>  
        </Box>
        :null */} 
        {listMetodoPago.length !==0 ?
        <Box mr={1}>
          <FormControl className={classes.formControl} size="small" style={{width:10+'rem' }}>
            <InputLabel htmlFor="age-native-simple">Metodo de Pago</InputLabel>
            <MaterialSelect style={{width: 10+"rem",borderRadius:3+'px'}} 
              native value={MetodoPago}   
              onChange={onChangeSelect}
              inputProps={{ name: 'MetodoPago', id: 'MetodoPago', }}            
            >
              <option aria-label="None" value="" />      
              {listMetodoPago.map((row) => (
              row.Id!==0&& <option value={row.Id}>{row.Descr}</option>
              ))}   
            </MaterialSelect>
          </FormControl>  
        </Box>
        :null}                 
      </Box> 
      <Box display={"flex"} flexDirection={"row"} my={1}>
      {listProveedor.length !==0 ?
        <Box mr={1}>
        <FormControl className={classes.formControl} size="small" style={{ width: 16+"rem",}}>
          <InputLabel htmlFor="age-native-simple">Proveedor</InputLabel>
          <MaterialSelect style={{width: 16+"rem",borderRadius:3+'px'}} 
            native value={Proveedor}   
            onChange={onChangeSelect}
            inputProps={{ name: 'Proveedor', id: 'Proveedor', }}            
          >
            <option aria-label="None" value="" />      
            {listProveedor.map((row) => (
             row.Id!==0&& <option value={row.Id}>{row.Alias}</option>
            ))}   
          </MaterialSelect>
        </FormControl>  
        </Box>
        :null} 
     {listProveedorCta.length !==0 ?
        <Box mr={1}>
        <FormControl className={classes.formControl} size="small" style={{width:12+'rem' }}>
          <InputLabel htmlFor="age-native-simple">Cuenta Proveedor</InputLabel>
          <MaterialSelect style={{width: 12+"rem",borderRadius:3+'px'}} 
            native value={ProvCta}   
            onChange={onChangeSelect}
            inputProps={{ name: 'ProvCta', id: 'ProvCta', }}            
          >
            <option aria-label="None" value="" />      
            {listProveedorCta.map((row) => (
             row.Id!==0&& <option value={row.Id}>{row.Alias}</option>
            ))}   
          </MaterialSelect>
        </FormControl>  
        </Box>
      :null}     
      </Box>
      <Box display={"flex"} flexDirection={"row"} width={"28rem"} style={{ marginTop:"1rem"}}>
        <Box>
        <FormControl component="fieldset" style={{width:12+'rem', }}>    
          <TextField id="Importe-TextArea" name="Importe" //rows="5" cols="100"
            label="Importe" style={{width: 12+"rem",borderRadius:3+'px'}} 
            variant='outlined' size='small'
            value={Importe} onChange={onChangeNum} />          
        </FormControl>    
        </Box>
        <FormControl component="fieldset" style={{width:12+'rem', marginLeft:"1rem"}}>    
          <TextField id="Impuesto-TextArea" name="Impuesto" //rows="5" cols="100"
            label="Impuesto" style={{width: 12+"rem",borderRadius:3+'px'}} 
            variant='outlined' size='small'
            value={Impuesto} onChange={onChangeNum} />          
        </FormControl>  
      </Box>
      <Box display={"flex"} flexDirection={"row"} width={"25rem"} style={{ marginTop:"1rem"}}>
        <FormControl component="fieldset" style={{width:25+'rem', }}>    
          <TextField id="Folio-TextArea" name="Folio" //rows="5" cols="100"
            label="Folio" style={{width: 25+"rem",borderRadius:3+'px'}} 
            variant='outlined' size='small'
            value={Folio} onChange={onChange} />          
        </FormControl>  
        
      </Box>
      <Box  mt={1}>
        <FormControl component="fieldset" fullWidth   style={{width:"29rem"}} >    
          <TextField id="CfdiLink-TextArea" name="CfdiLink" fullWidth //rows="5" cols="100"
            label="Link CFDi" style={{width:"29rem",borderRadius:3+'px'}} 
            variant='outlined' size='small'  
            value={CfdiLink} onChange={onChangeLink} />          
        </FormControl>  
      </Box>
      <Typography component="p" variant="body2" color='primary' 
        style={{margin:0,marginLeft:.5+'rem'}} >
        Nota
      </Typography>   
      <FormControl component="fieldset" style={{width:29+'rem'}}>    
        <textarea id="Descripcion-TextArea" name="Descripcion" rows="5"
          cols="100" placeholder="Nota" style={{width: 29+"rem",borderRadius:3+'px'}} 
          value={Descripcion} onChange={onChangeDesc} 
        />
      </FormControl>      
    
  </form>
  </Modal>
  );
}
 
export default NuevaBitacora;